import { useState } from "react";
import { AdminLogin } from "../components/admin/AdminLogin";
import { AdminDashboard } from "../components/admin/AdminDashboard";

export default function Admin() {
  const [authed, setAuthed] = useState(() => !!sessionStorage.getItem("rt_admin"));
  const logout = () => {
    sessionStorage.removeItem("rt_admin");
    setAuthed(false);
  };
  return authed ? <AdminDashboard onLogout={logout} /> : <AdminLogin onSuccess={() => setAuthed(true)} />;
}
